import { useCurrentReturnRequest } from "../../utils/current-return-request-context";

export const useReturnShippingCost = (): number => {
  const currentReturnRequest = useCurrentReturnRequest();
  return currentReturnRequest.financial_informations.return_shipping_paid
    .presentment_amount > 0
    ? -currentReturnRequest.financial_informations.return_shipping_paid
        .presentment_amount
    : currentReturnRequest.financial_informations.return_shipping_paid
        .presentment_amount;
};
